import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { HelperService } from '../services/helper.service';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'encodeHtmlSymbols',
})
export class EncodeHtmlSymbolsPipe implements PipeTransform {
    transform(text): string {
        return HelperService.escapeHtml(text);
    }
}
